import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';
import {
  DateTime,
} from 'luxon';
import {
  throwError,
} from './helpers';
import api from '../api';
import {
  normalizeLibrary,
} from './proResources';
import {
  fetchWorkoutEvents,
} from './workoutEvent';

export function* watchCheckLibrary(reportChannel) {
  const actions = createActionCreators('read', {
    resourceType: 'folders',
    requestKey: 'backgroundFetchLibrary',
  });
  yield eff.put(actions.pending());
  yield eff.put(
    reportChannel,
    {
      messageType: 'notify',
      message: {
        type: 'warn',
        key: 'dashboard.loading_library',
        settings: {
          autoClose: false,
        },
      },
    },
  );

  function* fetch() {
    try {
      const lib = yield eff.call(api.getLibrary);
      if (lib[0].items.find(i => i.name === 'Program Templates').items.length > 2) {
        // for dashboard activity
        const now = DateTime.local();
        yield eff.call(
          fetchWorkoutEvents,
          {
            params: {
              range_from: now.minus({ days: 7 }).toISO(),
              range_to: now.plus({ days: 7 }).toISO(),
              scope: 'all_with_clients',
            },
          },
        );

        const normalized = normalizeLibrary(lib);
        yield eff.put(actions.succeeded(normalized));

        yield eff.put(
          reportChannel,
          {
            messageType: 'notify',
            message: {
              type: 'dismiss',
            },
          },
        );

        yield eff.put(
          reportChannel,
          {
            messageType: 'notify',
            message: {
              type: 'success',
              key: 'dashboard.library_loaded',
            },
          },
        );
        yield eff.cancel();
      } else {
        yield eff.delay(5000);
        yield eff.fork(fetch);
      }
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, e);
    }
  }

  yield eff.delay(2000);
  yield eff.fork(fetch);
}

export function* getIntentTask(invoiceId) {
  function* getIntent() {
    try {
      const intent = yield eff.call(
        api.getPaymentIntents,
        {
          qs: {
            invoice_id: invoiceId,
          },
        },
      );

      return intent;
    } catch (e) {
      console.log(e);
    }

    return null;
  }

  while (true) {
    const intent = yield eff.call(getIntent);
    if (intent) {
      return intent;
    }

    yield eff.delay(3000);
  }
}
